module.exports = __webpack_public_path__ + "img/website_loading_animation.4b1f866d.gif";